<div class="row sc-empty-table-message">
  <div class="col-md-6 sc-empty-table-message__announcement">
    <p class="sc-empty-table-message__title" [innerHTML]="title"></p>
    <p class="sc-empty-table-message__message mt-1" [innerHTML]="message"></p>
    <sc-button
      class="d-none d-md-block"
      *ngIf="showButton"
      (onClick)="retryClicked()"
      id="reload-error-button"
      [loading]="buttonLoading"
      [prefixIcon]="buttonIcon"
    >
      {{ buttonText }}
    </sc-button>
  </div>
  <div class="col-md-6">
    <div class="sc-empty-table-message__image-container">
      <img [src]="imageSrc ? imageSrc : '/assets/images/papers.svg'" class="sc-empty-table-message__image img-fluid w-100">
    </div>
    <sc-button
      class="d-block d-md-none"
      *ngIf="showButton"
      (onClick)="retryClicked()"
      id="reload-error-button"
      [loading]="buttonLoading"
      [prefixIcon]="buttonIcon"
    >
      {{ buttonText }}
    </sc-button>
  </div>
</div>
